import React from 'react';
import {Typography} from 'antd';
import AppCard from '../layouts/app-card';

const SubmittedView = () => {
  return (
    <AppCard className='bg-[#FFFFFF6B] flex flex-col items-center p-5'>
      <Typography.Title className='text-center'>Activate Account</Typography.Title>
        <Typography.Paragraph className='!mb-10 text-center text-[16px]'>
            Confirm your email address to proceed.
        </Typography.Paragraph>
        <Typography.Paragraph className='!mb-10 text-[16px]'>
            You are almost done. An email from Sourcer has been sent to your email address.
        </Typography.Paragraph>
        <Typography.Paragraph className='text-[16px]'>
            Please follow the instructions in the email to finish setting up your Sourcer account.
        </Typography.Paragraph>
    </AppCard>
  );
};

export default SubmittedView;
